import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';
import {push} from 'react-router-redux';
import queryString from 'query-string';
import {Checkbox} from 'rmwc';

import * as styles from '../../styles';
import {request} from '../../containers/actions';
import CommentList from '../../social/comment';
import Tree from '../tree';
import {removeItemSelection} from '../tree/actions';
import {refresh as paginatorRefresh, removeItem, clearSelection} from '../../paginator/actions';
import PaginatedContainer from '../../paginator/paginated_container';
import examinationsFiltersSelectorGenerator from '../examinations/filters';
import { host_v2 } from '../../utilities/requests';


export default class Comments extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: false,
        actions: [],
        buttonActions: [],
        extraListFields: [],
        extraActions: [],
        extraFilters: [],
    }

    style = {items: {itemsList: {width: 'auto', overflowX: 'auto'}}}

    listFields = [
        {field: 'id', label: window.gettext('ID')},
        {field: item => item.user ? <a target='_blank' href={ host_v2 + `/Users?userId=${item.user.id}`}>{`${item.user.firstname} ${item.user.lastname}`}</a> : window.gettext('Guest User'), label: window.gettext('User')},
        {
            field: item => {
                const div = document.createElement('DIV');
                div.innerHTML = item.body;
                return div.innerText;
            },
            label: window.gettext('Text'),
            style: {
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                maxWidth: '30em',
            },
        },
        {
            field: item => <div
                style={{
                    backgroundColor: item.confirmed
                        ? styles.successBackColor
                        : styles.warningBackColor,
                    color: item.confirmed
                        ? styles.successColor
                        : styles.warningColor,
                    borderColor: item.confirmed
                        ? styles.successBorderColor
                        : styles.warningBorderColor,
                    textAlign: 'center',
                }}>
                {item.confirmed
                    ? window.gettext('Confirmed')
                    : window.gettext('Not confirmed')
                }
            </div>,
            label: window.gettext('Confirmed'),
        },
        {field: item => item.timestamp.toJalali().persian(), label: window.gettext('Timestamp')},
        ..._.map(this.props.extraListFields, field => ({
            field: eval(field.field),
            label: field.label,
        })),
    ]

    examinationsFiltersSelector = createSelector(
        [() => this.props.target_content_type],
        targetContentType => examinationsFiltersSelectorGenerator(
            targetContentType === 'examination' ? 'examination__' : 'multiple_choice_paper__examination__',
        ),
    )

    filtersSelector = createSelector.bind(this)(
        [
            (__, props) => props.location,
            ..._.includes(['book', 'chapter'], this.props.target_content_type)
                ? [
                    store => store.get('gradesTreeFilter'),
                    store => store.get('booksTreeFilter'),
                    store => store.get('chaptersTreeFilter'),
                ]
                : _.includes(['multiple-choice-paper', 'examination'], this.props.target_content_type)
                    ? [
                        store => this.examinationsFiltersSelector(this.props)(store.get('examinationFilters')),
                        store => store.getIn(['examinationsTreeFilter']),
                    ]
                    : [],
        ],
        (location, filters) => {
            let confirmedState = location.query.confirmed || [];
            if (!(confirmedState instanceof Array))
                confirmedState = [confirmedState];
            confirmedState = _.map(confirmedState, confirmed => confirmed === 'true');
            return [
                ...(this.props.target_category
                    ? [{
                        field: 'target_category',
                        selected: {[this.props.target_category]: undefined},
                    }]
                    : []
                ),
                ...(this.props.target_content_type
                    ? [{
                        field: 'target_content_type',
                        selected: {[this.props.target_content_type]: undefined},
                    }]
                    : []
                ),
                {
                    field: 'confirmed',
                    label: window.gettext('Confirm'),
                    component: <div>
                        <div
                            style={{
                                display: 'block',
                                float: 'right',
                                width: '10em',
                                cursor: 'pointer',
                            }}>
                            <Checkbox
                                checked={_.includes(confirmedState, true)}
                                onChange={this.confirmedChanged.bind(
                                    this,
                                    true,
                                )}>
                                {window.gettext('Confirmed')}
                            </Checkbox>
                        </div>
                        <div
                            style={{
                                display: 'block',
                                float: 'right',
                                width: '10em',
                                cursor: 'pointer',
                            }}>
                            <Checkbox
                                checked={_.includes(confirmedState, false)}
                                onChange={this.confirmedChanged.bind(
                                    this,
                                    false,
                                )}>
                                {window.gettext('Not confirmed')}
                            </Checkbox>
                        </div>
                    </div>,
                    selected: _.mapValues(
                        _.mapKeys(confirmedState, state => state ? 'True' : 'False'),
                        confirmed => confirmed ? window.gettext('Confirmed') : window.gettext('Not confirmed'),
                    ),
                },
                ..._.includes(['book', 'chapter'], this.props.target_content_type)
                    ? [
                        {
                            field: 'grade',
                            label: window.gettext('Grade'),
                            component: <div style={{fontSize: '.8rem'}}>
                                <Tree
                                    store={this.props.store.get('gradesTreeFilter')}
                                    readonly
                                    header
                                    resource='grade'
                                    itemLabel='title'
                                    label={window.gettext('Grade')}
                                />
                            </div>,
                            selected: this.props.store.getIn(['gradesTreeFilter', 'selected']).toJS(),
                            remove: id => this.context.store.dispatch(removeItemSelection(
                                id,
                                'grade',
                                this.props.store.getIn(['gradesTreeFilter', 'elementId']),
                            )),
                        },
                        {
                            field: 'book',
                            label: window.gettext('Book'),
                            component: <div style={{fontSize: '.8rem'}}>
                                <Tree
                                    store={this.props.store.get('booksTreeFilter')}
                                    readonly
                                    header
                                    resource='book'
                                    itemLabel={book => `${book.grade ? book.grade.title : ''} - ${book.title}`}
                                    filter={{
                                        grade: this.props.store.getIn(['gradesTreeFilter', 'selected']).keySeq().join(',') || -1,
                                    }}
                                    label={window.gettext('Book')}
                                />
                            </div>,
                            selected: this.props.store.getIn(['booksTreeFilter', 'selected']).toJS(),
                            remove: id => this.context.store.dispatch(removeItemSelection(
                                id,
                                'book',
                                this.props.store.getIn(['booksTreeFilter', 'elementId']),
                            )),
                        },
                        {
                            field: 'chapter',
                            label: window.gettext('Chapter'),
                            component: <div style={{fontSize: '.8rem'}}>
                                <Tree
                                    store={this.props.store.get('chaptersTreeFilter')}
                                    readonly
                                    header
                                    resource='chapter'
                                    itemLabel={chapter => `${chapter.book.grade ? chapter.book.grade.title : ''}` +
                                            `- ${chapter.book.title} - ${chapter.caption}`
                                    }
                                    filter={{
                                        book: this.props.store.getIn(['booksTreeFilter', 'selected']).keySeq().join(',') || -1,
                                    }}
                                    label={window.gettext('Chapter')}
                                />
                            </div>,
                            selected: this.props.store.getIn(['chaptersTreeFilter', 'selected']).toJS(),
                            remove: id => this.context.store.dispatch(removeItemSelection(
                                id,
                                'chapter',
                                this.props.store.getIn(['chaptersTreeFilter', 'elementId']),
                            )),
                        },
                    ]
                    : _.includes(['multiple-choice-paper', 'examination'], this.props.target_content_type)
                        ? [
                            ...filters,
                            {
                                field: this.props.target_content_type === 'examination' ? 'examination' : 'multiple_choice_paper__examination',
                                label: window.gettext('Examination'),
                                component: <div style={{fontSize: '.8rem'}}>
                                    <Tree
                                        store={this.props.store.get('examinationsTreeFilter')}
                                        readonly
                                        header
                                        resource='examination'
                                        itemLabel={examination => _.map(
                                            examination.grades,
                                            grade => grade.title,
                                        ).join(window.gettext(',') + ' ') + ' - ' + examination.title}
                                        filter={{
                                            grades: this.props.store.getIn([
                                                'examinationFilters',
                                                'gradesTreeFilter',
                                                'selected',
                                            ]).keySeq().join(',') || -1,
                                            'examination_type': this.props.store.getIn([
                                                'examinationFilters',
                                                'typesTreeFilter',
                                                'selected',
                                            ]).keySeq().join(','),
                                            step: this.props.store.getIn([
                                                'examinationFilters',
                                                'stepsTreeFilter',
                                                'selected',
                                            ]).keySeq().join(','),
                                            online: this.props.store.getIn([
                                                'examinationFilters',
                                                'onlineTreeFilter',
                                                'selected',
                                            ]).keySeq().join(','),
                                            restricted: this.props.store.getIn([
                                                'examinationFilters',
                                                'restrictedTreeFilter',
                                                'selected',
                                            ]).keySeq().join(','),
                                            registered: this.props.store.getIn([
                                                'examinationFilters',
                                                'registeredTreeFilter',
                                                'selected',
                                            ]).keySeq().join(','),
                                            'date__range': this.props.store.getIn(['examinationFilters', 'yearsTreeFilter', 'selected']).size
                                                ? Number(this.props.store.getIn([
                                                    'examinationFilters',
                                                    'yearsTreeFilter',
                                                    'selected',
                                                ]).keySeq().sort().first().split(':')[0] / 1000 - 4017600) + ',' + Number(this.props.store.getIn([
                                                    'examinationFilters',
                                                    'yearsTreeFilter',
                                                    'selected',
                                                ]).keySeq().sort().last().split(':')[1] / 1000 - 4017600)
                                                : '-1,-1',
                                            'books__isnull': 'True',
                                        }}
                                        label={window.gettext('Examination')}
                                    />
                                </div>,
                                selected: this.props.store.getIn(['examinationsTreeFilter', 'selected']).toJS(),
                                remove: id => this.context.store.dispatch(removeItemSelection(
                                    id,
                                    'examination',
                                    this.props.store.getIn(['examinationsTreeFilter', 'elementId']),
                                )),
                            },
                        ]
                        : [],
                ..._.map(this.props.extraFilters, item => ({
                    ...item,
                    selected: eval(item.selected)(this.props),
                })),
            ];
        },
    )

    sorts = [
        {name: 'id', label: window.gettext('ID'), reversed: true},
        {name: 'national_id', label: window.gettext('national id')},
        {name: 'firstname', label: window.gettext('firstname')},
        {name: 'lastname', label: window.gettext('lastname')},
    ]

    actionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
            () => this.props.store.getIn(['paginator', 'selected']).size > 0,
        ],
        () => this.props.readonly
            ? this.props.actions
            : this.props.store.getIn(['paginator', 'selected']).size === 0
                ? this.props.actions
                : _.concat(
                    this.props.actions,
                    [
                        {
                            label: window.gettext('Remove'),
                            action: async () => {
                                if (!window.confirm(window.interpolate(
                                    window.gettext('Are you sure you wanna remove these %(count)s comments?'),
                                    {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                    true,
                                )))
                                    return;
                                await this.context.store.dispatch(request({
                                    path: '/comment/?' + queryString.stringify({
                                        id: this.props.store.getIn(['paginator', 'selected']).keySeq().join(','),
                                    }),
                                    method: 'DELETE',
                                }));
                                this.context.store.dispatch([
                                    ..._.map(
                                        this.props.store.getIn(['paginator', 'selected']).keySeq().toArray(),
                                        id => removeItem(
                                            id,
                                            this.props.store.getIn(['paginator', 'elementId']),
                                        ),
                                    ),
                                    clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                    paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                                ]);
                            },
                        },
                        {
                            label: window.gettext('Confirm'),
                            action: async () => {
                                if (!window.confirm(window.interpolate(
                                    window.gettext('Are you sure you wanna confirm these %(count)s comments?'),
                                    {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                    true,
                                )))
                                    return;
                                await this.context.store.dispatch(request({
                                    path: '/comment/',
                                    body: this.props.store.getIn(['paginator', 'selected']).map((comment, id) => ({id, confirmed: true})).toArray(),
                                    method: 'PATCH',
                                }));
                                this.context.store.dispatch([
                                    clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                    paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                                ]);
                            },
                        },
                        {
                            label: window.gettext('Unconfirm'),
                            action: async () => {
                                if (!window.confirm(window.interpolate(
                                    window.gettext('Are you sure you wanna unconfirm these %(count)s comments?'),
                                    {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                    true,
                                )))
                                    return;
                                await this.context.store.dispatch(request({
                                    path: '/comment/',
                                    body: this.props.store.getIn(['paginator', 'selected']).map(
                                        (comment, id) => ({id, confirmed: false}),
                                    ).toArray(),
                                    method: 'PATCH',
                                }));
                                this.context.store.dispatch([
                                    clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                    paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                                ]);
                            },
                        },
                    ],
                    ..._.map(this.props.extraActions, action => ({
                        label: action.label,
                        action: async () => {
                            if (!window.confirm(window.interpolate(
                                window.gettext('Are you sure you wanna %(verb)s these %(count)s comments?'),
                                {verb: action.verb || action.label, count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                true,
                            )))
                                return;
                            await this.context.store.dispatch(request({
                                path: '/comment/',
                                body: this.props.store.getIn(['paginator', 'selected']).map((comment, id) => ({
                                    id,
                                    extra: {...comment.extra, ...action.change},
                                })).toArray(),
                                method: 'PATCH',
                            }));
                            this.context.store.dispatch([
                                clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                            ]);
                        },
                    })),
                )
    )

    tooltip(item) {
        const div = document.createElement('DIV');
        div.innerHTML = item.body;
        return div.innerText;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.params.id && !this.props.params.id) {
            this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
        }
    }

    confirmedChanged(confirmed, event) {
        event.stopPropagation();
        let confirmedState = this.props.location.query.confirmed || [];
        if (!(confirmedState instanceof Array))
            confirmedState = [confirmedState];
        confirmedState = _.map(confirmedState, confirmed => confirmed === 'true');
        if (_.includes(confirmedState, confirmed)) {
            _.remove(confirmedState, s => s === confirmed);
            this.context.store.dispatch(push({
                ...this.props.location,
                query: {...this.props.location.query, confirmed: confirmedState},
            }));
        }
        else {
            this.context.store.dispatch(push({
                ...this.props.location,
                query: {
                    ...this.props.location.query,
                    confirmed: [confirmed],
                },
            }));
        }
    }

    render() {
        if (this.props.params.id)
            return <div style={{width:  'calc(100% - 21.5em)'}}>
                <CommentList
                    target={this.props.store.getIn(['paginator', 'data']).find(
                        item => item.get('id') === Number.parseInt(this.props.params.id),
                    ).get('target').toJS()}
                    submitMessage={null}
                    refresh={() => {
                        const path = this.context.store.getState().getIn(
                            ['routing', 'locationBeforeTransitions', 'pathname'],
                        );
                        this.context.store.dispatch(push(path.split('/').slice(0, -2).join('/') + '/'));
                    }}
                    actions={[
                        {
                            icon: comment => comment.extra.accepted
                                ? 'fa-check-circle'
                                : comment.extra.accepted === false
                                    ? 'fa-times-circle'
                                    : 'fa-info-circle',
                            action: async (comment, props) => {
                                await this.context.store.dispatch(request({
                                    path: `/comment/${comment.id}/`,
                                    method: 'PATCH',
                                    body: {extra: {
                                        ...comment.extra,
                                        accepted: comment.extra.accepted
                                            ? false
                                            : comment.extra.accepted === false
                                                ? null
                                                : true,
                                    }},
                                }));
                                props.refresh();
                            },
                        },
                    ]}
                />
            </div>;
        return <PaginatedContainer
            store={this.props.store.get('paginator')}
            resource='comment'
            style={this.style}
            listFields={this.listFields}
            tooltip={this.tooltip}
            title={this.props.title || window.gettext('Comments')}
            selectable
            filters={this.filtersSelector(this.props.store, this.props)}
            sorts={this.sorts}
            pageSize={this.props.pageSize}
            actions={this.actionsSelector(this.props.store)}
            buttonActions={this.props.buttonActions}
        />;
    }
}
